import { __rest, __assign, __makeTemplateObject } from 'tslib';
import React, { useState, forwardRef } from 'react';
import { styled } from 'styled-components';
import classnames from 'classnames';
import { IconChevronDown, IconChevronRight } from 'suomifi-icons';
import '../../../../reset/HtmlA/HtmlA.js';
import { HtmlButton } from '../../../../reset/HtmlButton/HtmlButton.js';
import { HtmlDiv } from '../../../../reset/HtmlDiv/HtmlDiv.js';
import '../../../../reset/HtmlFieldSet/HtmlFieldSet.js';
import '../../../../reset/HtmlH/HtmlH.js';
import '../../../../reset/HtmlInput/HtmlInput.js';
import '../../../../reset/HtmlLabel/HtmlLabel.js';
import '../../../../reset/HtmlLegend/HtmlLegend.js';
import '../../../../reset/HtmlLi/HtmlLi.js';
import { HtmlNav } from '../../../../reset/HtmlNav/HtmlNav.js';
import '../../../../reset/HtmlOl/HtmlOl.js';
import '../../../../reset/HtmlSpan/HtmlSpan.js';
import '../../../../reset/HtmlTextarea/HtmlTextarea.js';
import { HtmlUl } from '../../../../reset/HtmlUl/HtmlUl.js';
import '../../../../reset/HtmlTable/HtmlTable.js';
import '../../../../reset/HtmlTable/HtmlTableCaption.js';
import '../../../../reset/HtmlTable/HtmlTableHeader.js';
import '../../../../reset/HtmlTable/HtmlTableRow.js';
import '../../../../reset/HtmlTable/HtmlTableBody.js';
import '../../../../reset/HtmlTable/HtmlTableHeaderCell.js';
import '../../../../reset/HtmlTable/HtmlTableCell.js';
import { SuomifiThemeConsumer } from '../../../theme/SuomifiThemeProvider/SuomifiThemeProvider.js';
import '../../../theme/SuomifiTheme/SuomifiTheme.js';
import { SpacingConsumer } from '../../../theme/SpacingProvider/SpacingProvider.js';
import { separateMarginProps } from '../../../theme/utils/spacing.js';
import { getConditionalAriaProp } from '../../../../utils/aria/aria.js';
import { baseStyles } from './WizardNavigation.baseStyles.js';
import { filterDuplicateKeys } from '../../../../utils/common/common.js';

var baseClassName = 'fi-wizard-navigation';
var smallScreenClassName = "".concat(baseClassName, "--small-screen");
var dividerClassName = "".concat(baseClassName, "_divider");
var listClassName = "".concat(baseClassName, "_list");
var headingClassName = "".concat(baseClassName, "_heading");
var BaseWizardNavigation = function BaseWizardNavigation(_a) {
  var _b;
  var children = _a.children,
    ariaLabel = _a["aria-label"],
    id = _a.id,
    variant = _a.variant,
    initiallyExpanded = _a.initiallyExpanded,
    heading = _a.heading,
    className = _a.className,
    forwardedRef = _a.forwardedRef,
    style = _a.style,
    rest = __rest(_a, ["children", 'aria-label', "id", "variant", "initiallyExpanded", "heading", "className", "forwardedRef", "style"]);
  var _c = separateMarginProps(rest),
    passProps = _c[1];
  var initiallyExpandedValue = initiallyExpanded !== undefined ? initiallyExpanded : true;
  var _d = useState(initiallyExpandedValue),
    smallScreenNavOpen = _d[0],
    setSmallScreenNavOpen = _d[1];
  return /*#__PURE__*/React.createElement(HtmlDiv, __assign({
    className: classnames(baseClassName, className, (_b = {}, _b[smallScreenClassName] = variant === 'smallScreen', _b)),
    style: style
  }, passProps), variant === 'smallScreen' ? ( /*#__PURE__*/React.createElement(HtmlButton, {
    className: headingClassName,
    onClick: function onClick() {
      return setSmallScreenNavOpen(!smallScreenNavOpen);
    },
    "aria-expanded": smallScreenNavOpen
  }, heading, smallScreenNavOpen ? /*#__PURE__*/React.createElement(IconChevronDown, null) : /*#__PURE__*/React.createElement(IconChevronRight, null))) : ( /*#__PURE__*/React.createElement(HtmlDiv, {
    className: headingClassName
  }, heading)), (variant === 'smallScreen' && smallScreenNavOpen || variant !== 'smallScreen') && ( /*#__PURE__*/React.createElement(HtmlNav, __assign({
    forwardedRef: forwardedRef,
    id: id
  }, getConditionalAriaProp('aria-label', [ariaLabel])), /*#__PURE__*/React.createElement(HtmlDiv, {
    className: dividerClassName
  }), /*#__PURE__*/React.createElement(HtmlUl, {
    className: listClassName,
    role: "list"
  }, children))));
};
var StyledWizardNavigation = styled(function (props) {
  props.theme;
    props.globalMargins;
    var passProps = __rest(props, ["theme", "globalMargins"]);
  return /*#__PURE__*/React.createElement(BaseWizardNavigation, __assign({}, passProps));
}).withConfig({
  componentId: "sc-lz5k9z-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    globalMargins = _a.globalMargins,
    rest = __rest(_a, ["theme", "globalMargins"]);
  var _b = separateMarginProps(rest),
    marginProps = _b[0];
  var cleanedGlobalMargins = filterDuplicateKeys(globalMargins.wizardNavigation, marginProps);
  return baseStyles(theme, cleanedGlobalMargins, marginProps);
});
var WizardNavigation = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SpacingConsumer, null, function (_a) {
    var margins = _a.margins;
    return /*#__PURE__*/React.createElement(SuomifiThemeConsumer, null, function (_a) {
      var suomifiTheme = _a.suomifiTheme;
      return /*#__PURE__*/React.createElement(StyledWizardNavigation, __assign({
        theme: suomifiTheme,
        globalMargins: margins,
        forwardedRef: ref
      }, props));
    });
  });
});
WizardNavigation.displayName = 'WizardNavigation';
var templateObject_1;

export { WizardNavigation };
//# sourceMappingURL=WizardNavigation.js.map
